/** ¿El alumno aún no ha empezado? (chip "Empieza el ..."). */
export function isFutureStart(student) {
    if (!student.start_date)
        return false;
    const now = new Date();
    const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    return student.start_date > today;
}
/** DD/MM/YYYY para el chip "Empieza el ...". */
export function formatStartDate(startDate) {
    const [y, m, d] = startDate.split('-');
    return `${d}/${m}/${y}`;
}
//# sourceMappingURL=types.js.map